document.addEventListener( 'DOMContentLoaded', function() {
  const targetElement = document.querySelector( '.e-stn--blog-inner-banner' );
  if ( targetElement ) {
    targetElement.classList.add( 'show-svg' );
  }
} );